import styled, { th } from '@xstyled/styled-components'
import { Button } from '../button'

export const StyledShareButtonWithText = styled(Button).attrs({
  variant: 'ghost'
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: auto;
  border-radius: 4px;
  padding: 8px;

  &:focus {
    box-shadow: none;
  }
  & span.button-icon {
    width: 40px;
    height: 40px;
    margin: 0;
  }

  & span.button-text {
    font-size: 10px;
    color: ${th.color('grey.d2')};
    width: 50px;
  }
`

export const StyledShareButton = styled.button({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 8
})
